import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hook';
import { closeModal, selectIsOpen } from '../../store/features/modalSlice';

const Modal = () => {
  const dispatch = useAppDispatch();
  const modalState = useAppSelector((state) => state.modal);
  const blurCSS = modalState.option?.removeBlur ? '' : 'backdrop-blur-sm';
  const hiddenCSS = modalState.open ? '' : 'hidden';
  const isOpen = useAppSelector(selectIsOpen);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [isOpen]);

  // 새로고침시 모달창 닫기
  useEffect(() => {
    dispatch(closeModal());
  }, []);

  return (
    // 열린 상태일 때만 모달창 렌더링
    <div
      className={`fixed left-0 top-0 z-[10002] flex h-full w-full items-center justify-center bg-black bg-opacity-50 ${blurCSS} ${hiddenCSS}`}
    >
      {/* JSX 렌더링 가능한 경우 체크 ( 명확하지 않음 ) */}
      {modalState.body.type ? modalState.body : <></>}
    </div>
  );
};

export default Modal;
